// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__iKJpt","faqQuestion":"Faq_faqQuestion__ND0Z5","faqAnswer":"Faq_faqAnswer__LNgvH","open":"Faq_open__p2hEU"};